'use client'

import { Card, Col, LoadMoreSection, Skeleton } from '@repo/ui/components'
import { MessageItem } from './message.item'
import { useAgentInboxListMessages } from '@repo/services'
import { MessagesEmptyState } from './messages.empty-state'

export const MessageItems = ({
  tab,
}: {
  tab: 'security' | 'system' | 'announcement' | 'otc' | 'payment' | 'all'
}) => {
  const {
    data: messages,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isLoading,
  } = useAgentInboxListMessages({
    messageType: tab === 'all' ? undefined : tab,
    skip: 0,
    limit: 10,
  })

  const messageItems =
    messages?.pages.flatMap((page) => page.data?.messages || []) || []
  return (
    <Card className='!gap-3xl' withoutBorder>
      {messageItems.map((message) => (
        <MessageItem key={message.id} message={message} />
      ))}
      <LoadMoreSection
        fetchNextPage={fetchNextPage}
        hasNextPage={hasNextPage}
        isFetchingNextPage={isFetchingNextPage}
        isLoading={isLoading}
      />{' '}
      {isLoading && (
        <Col className='gap-md px-md'>
          {Array.from({ length: 10 }).map((_, index) => (
            <Skeleton key={index} className='w-full h-20   rounded-md ' />
          ))}
        </Col>
      )}
      {messageItems.length === 0 && <MessagesEmptyState />}
    </Card>
  )
}
